import { OrderDeliveryType, OrderStatus } from "@/interfaces";
import { PaymentDetailsMethod } from "@/interfaces/payments";
import { z } from "zod";

const AddressSchema = z
  .object({
    zipCode: z.string().optional(),
    city: z.string(),
    neighborhood: z.string(),
    line1: z.string(),
    line2: z.string().optional(),
    number: z.string(),
  })
  .optional();

// Order Delivery Schema
const OrderDeliverySchema = z
  .object({
    deliveryType: z.nativeEnum(OrderDeliveryType).default(OrderDeliveryType.WITHDRAWAL),
    deliveryAt: z.date().optional(),
    deliveryValue: z.number().min(0).optional(),
    address: AddressSchema,
  })
  .refine(
    (data) => {
      if (data.deliveryType === OrderDeliveryType.DELIVERY) {
        return data.address !== undefined;
      }
      return true;
    },
    {
      message: "Endereço é obrigatório para entregas",
      path: ["address"],
    }
  );

export const PaymentDetailsSchema = z.object({
  method: z.nativeEnum(PaymentDetailsMethod),
  paymentDate: z.date(),
  amount: z.number(),
});

// Order Input Schema
export const schema = z.object({
  customerId: z.string().optional(),
  products: z
    .array(
      z.object({
        productId: z.string().min(1, "Produto é obrigatório"),
        quantity: z.number().min(1, "Quantidade deve ser maior que zero"),
        additionals: z
          .array(
            z.object({
              itemId: z.string().min(1, "Adicional inválido"),
              quantity: z.number().min(1, "Quantidade do adicional deve ser maior que zero"),
            })
          )
          .optional(),
        observation: z.string().optional(),
      })
    )
    .min(1, "Selecione pelo menos um produto"),
  status: z.nativeEnum(OrderStatus).optional(),
  orderDate: z.date(),
  preparationDate: z.date(),
  delivery: OrderDeliverySchema,
  additional: z.number().min(0).default(0),
  discount: z.number().min(0).default(0),
  description: z.string().optional(),
  tags: z.array(z.string()).default([]),
});

